module.exports = __webpack_public_path__ + "img/lea-27.8fa1658b.png";